import type { ReactNode } from "react";

interface CardProps {
  title?: string;
  titleSize?: "xs" | "sm" | "md" | "lg" | "xl";
  href?: string;
  children: ReactNode;
  className?: string;
}

const titleSizeMap: Record<NonNullable<CardProps["titleSize"]>, string> = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
  xl: "text-xl",
};

export default function Card({
  title,
  titleSize = "sm",
  href,
  children,
  className = "",
}: Readonly<CardProps>) {
  return (
    <div
      className={`rounded-xl text-white p-4 h-full w-full bg-card-dark ${className}`}>
      {title && (
        <div>
          {href ? (
            <a
              href={href}
              className={`${titleSizeMap[titleSize]} hover:underline`}>
              {title}
            </a>
          ) : (
            <h3 className={titleSizeMap[titleSize]}>{title}</h3>
          )}
        </div>
      )}
      <div
        className={`flex justify-start h-full w-full flex-col ${title && "justify-center! -mt-2"}`}>
        {children}
      </div>
    </div>
  );
}
